import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Input, Button, DatePicker, Table, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import request from "../../util/request";
import PointsModal from "../../components/points/pointsModal";
import "./PointsPage.css";

const initMonth = () => {
  const date = new Date();
  const month = date.getFullYear() + "/" + (date.getMonth() + 1);
  return month;
};
const PointsExpandPage = () => {
  const [month, setMonth] = useState("");
  const [points, setPoints] = useState("");
  const [memeberNumber, setMemberNumber] = useState("");
  const [data, setData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [cLoading, setCLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [detailData, setDetailData] = useState(null);
  const [mode, setMode] = useState(0);

  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const toLogin = () => {
    navigate("/login");
  };
  const onMonthInput = (date, dateString) => {
    setMonth(dateString);
  };
  const onPointsInput = (e) => {
    setPoints(e.target.value);
  };
  const goCalculate = async () => {
    setMode(1);
    setCLoading(true);
    try {
      const res = await request.post(
        `/api/xcx-user/parent/computeMemberReward`,
        {
          pageNum,
          pageSize,
          totalPoints: points,
        }
      );
      setData(res?.list || []);
      setTotal(res?.total || 0);
    } catch (error) {
      message.error(error?.message);
    } finally {
      setCLoading(false);
    }
  };
  const goDispatch = () => {
    setTitle("发放确认");
    setIsModalOpen(true);
    setDetailData({ total: memeberNumber, points, type: "member" });
  };
  const getSearchData = async () => {
    setMode(0);
    setLoading(true);
    try {
      const res = await request.get(
        `/api/xcx-user/parent/memberlist?pageNum=${pageNum}&pageSize=${pageSize}`
      );
      setData(res?.list || []);
      setTotal(res?.total || 0);
    } catch (error) {
      message.error(error?.message);
    } finally {
      setLoading(false);
    }
  };

  // 获取会员总人数
  const getMemeberCount = async () => {
    try {
      const res = await request.get("/api/xcx-user/parent/membercount");
      setMemberNumber(res);
    } catch (error) {
      message.error(error?.message);
    }
  };

  useEffect(() => {
    getMemeberCount();
  }, []);
  useEffect(() => {
    if (!data.length) return;
    if (mode) goCalculate();
    else getSearchData();
  }, [pageSize, pageNum]);

  const columns = [
    {
      title: "序号",
      dataIndex: "no",
      render: (text, record, index) => index + 1,
    },
    { title: "ID号", dataIndex: "userId" },
    { title: "充值金额", dataIndex: "rechargeAmount" },
    {
      title: "会员充值总金额",
      dataIndex: "totalPlatformRecharge",
    },
    { title: "会员金额所占比例", dataIndex: "rechargeRatio" },
    {
      title: "本月发放积分（未分配前为0，分配后为具体数字）",
      dataIndex: "amount",
    },
  ];

  return (
    <div className="points-container">
      <div className="middlePart search-mod">
        <div className="points-left">
          {/* <DatePicker
            defaultValue={dayjs(month, "YYYY/MM")}
            format={"YYYY/MM"}
            onChange={onMonthInput}
            placeholder="选择月份"
            picker="month"
            style={{ width: "200px", marginRight: "12px" }}
          /> */}
          <Button
            loading={loading}
            onClick={getSearchData}
            type="primary"
            icon={<SearchOutlined />}
            iconPosition="start"
          >
            Search
          </Button>
        </div>
        <div className="points-right">
          <span style={{ marginRight: "8px" }}>
            会员用户总数：{memeberNumber}人
          </span>
          <Input
            value={points}
            onInput={onPointsInput}
            className="input"
            placeholder="输入会员总分配积分"
            style={{ width: "150px" }}
          />
          <Button
            disabled={!points}
            onClick={goCalculate}
            style={{ marginRight: "8px" }}
            type="primary"
          >
            计算
          </Button>
          <Button disabled={!points} onClick={goDispatch} type="primary">
            发放
          </Button>
        </div>
      </div>
      <div className="table">
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: pageNum,
            pageSize: pageSize,
            total,
            onChange: (pageNum, pageSize) => {
              setPageNum(pageNum);
              setPageSize(pageSize);
            },
            showSizeChanger: true,
            showTotal: (total) => `共 ${total} 条数据`,
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          loading={loading || cLoading}
          rowKey="userId"
        />
      </div>
      <PointsModal
        title={title}
        visible={isModalOpen}
        footer={[]}
        closeDialog={() => setIsModalOpen(false)}
        data={detailData}
      />
    </div>
  );
};

export default PointsExpandPage;
